import { CompanyType } from '@api';
import {
  Anchor,
  getValueByPath,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
} from '@common';
import { useTranslation } from 'react-i18next';
import { GeneralInformationTableRowType } from '../../types';

type GeneralInformationTableRowPropsType = {
  company: CompanyType;
  row: GeneralInformationTableRowType;
};

export const GeneralInformationTableRow: React.FC<
  GeneralInformationTableRowPropsType
> = ({ company, row }) => {
  const { t } = useTranslation('companyDetailsGeneral');

  const getRenderValue = () => {
    const value = getValueByPath(company, row.accessor);
    const noDataPlaceholder = t('NO_DATA_PLACEHOLDER', { ns: 'common' });

    switch (row.accessor) {
      case 'website':
        if (!company.website) return noDataPlaceholder;
        return (
          <Anchor to={company.website} target="_blank">
            {company.website}
          </Anchor>
        );
      case 'tags':
        if (company.tags.length === 0) return noDataPlaceholder;
        return company.tags
          .map((tag) => t(`TAGS.${tag}`, { ns: 'companies' }))
          .join(', ');
      case 'notes':
        if (company.notes === null || company.notes === '') {
          return noDataPlaceholder;
        }
        return (
          <span style={{ whiteSpace: 'pre-wrap' }}>{company.notes}</span>
        );
      default:
        if (value === null || value === undefined || value === '') {
          return noDataPlaceholder;
        }
        return String(value);
    }
  };

  return (
    <TouringCardTableRow>
      <TouringCardTableRowLabel>
        {t(`GENERAL_INFORMATION.ROWS.${row.label}`)}
      </TouringCardTableRowLabel>
      <TouringCardTableRowValue>{getRenderValue()}</TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};
